import { fillLastColumn } from "@/components/DataTable/columnResize";

export const MIN_FIELD_COL_W = 80;
// What a double-click shrinks a column to. Above the minimum, so one gesture
// still leaves a column readable while a drag can go narrower; tighter than
// the Tables grid's, since these live in a side panel.
export const NARROW_FIELD_COL_W = 144;
export const DEFAULT_FIELD_COL_W = 150;
// Row-number column. Same width as the delete column, so the two gutters
// balance and a three-digit row number still has room to breathe.
export const FIELD_UTILITY_COL_W = 40;
// Delete column, pinned to the right edge. Wider than the row numbers so the
// icon button sits centred in it, matching the Tables grid's add-column cell.
export const FIELD_DELETE_COL_W = 40;

export function parseStoredWidths(raw: string | null): Record<string, number> {
  if (!raw) return {};
  try {
    const parsed: unknown = JSON.parse(raw);
    if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed))
      return {};
    const out: Record<string, number> = {};
    for (const [name, w] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof w === "number" && Number.isFinite(w))
        out[name] = Math.max(MIN_FIELD_COL_W, w);
    }
    return out;
  } catch {
    return {};
  }
}

// The last column absorbs any slack the others leave, so the table always
// spans its container; over-full overflows into scroll.
export function computeFieldColumnWidths({
  columnNames,
  storedWidths,
  containerW,
  fixedW,
}: {
  columnNames: string[];
  storedWidths: Record<string, number>;
  containerW: number;
  fixedW: number;
}): { dataWidths: number[]; tableWidth: number } {
  const nominal = columnNames.map(
    (name) => storedWidths[name] ?? DEFAULT_FIELD_COL_W
  );
  const dataWidths =
    containerW > 0 ? fillLastColumn(nominal, containerW - fixedW) : nominal;
  return {
    dataWidths,
    tableWidth: dataWidths.reduce((a, b) => a + b, 0) + fixedW,
  };
}
